<template>
	<ParamWrapper v-bind="wrapperProps" @input-data-closed="onDataInputMenuClose">
		<component :is="component" v-bind="componentProps" v-on="componentListeners" />
		<template #input-data>
			<ListStringDataInputMenu :param="param" :items="tableItems" v-on="dataInputListeners" ref="data-input-menu" />
		</template>
	</ParamWrapper>
</template>

<script>
import InListStringParamType from './InListStringParamType';
export default { ...InListStringParamType, name: 'InListDefaultParamType' };
</script>
<style lang="scss" scoped></style>
